import { z } from 'zod';

export const ProjectStatus = z.enum([
  'DEFAULT',
  'DRAFT',
  'PUBLISH',
  'DELETED',
  'DEFAULT_TOOLER',
]);

export type ProjectStatusT = z.infer<typeof ProjectStatus>;
